const getUpgradeLevel = (maxSkillPoints, updatePoints, actualLevel) => {
    const maxLevel =
        Math.abs(
            maxSkillPoints - updatePoints >= 0 ? updatePoints : maxSkillPoints
        ) + actualLevel
    return maxLevel
}

const getMinimumLevel = (skillIndex) => {
    const minimunLevel = skillIndex === 0 ? 1 : 0
    return minimunLevel
}

const ableToUpdate = (
    actualLevel,
    updatePoints,
    maxLevel,
    skillInfo,
    charlevel,
    maxSkillPoints
) =>
    actualLevel + updatePoints >= 0 &&
    actualLevel + updatePoints <= maxLevel &&
    skillInfo.levelsInfo[
        actualLevel + updatePoints === 0 ? 0 : actualLevel + updatePoints - 1
    ].necessaryLevel <= charlevel &&
    maxSkillPoints - updatePoints >= 0

const getMaxLevel = (validLevelsSize, upgradeLevel) => {
    const maxLevel =
        upgradeLevel >= validLevelsSize ? validLevelsSize : upgradeLevel
    return maxLevel
}

const updagradeMax = (
    skillInfo,
    charLevel,
    maxSkillPoints,
    updatePoints,
    updateSkillsLevels,
    actualLevel,
    indexClicked
) => {
    const filteredLevels = skillInfo.levelsInfo.filter(
        (skillLevel) => skillLevel.necessaryLevel <= charLevel
    )
    const upgradeLevel = getUpgradeLevel(
        maxSkillPoints,
        updatePoints,
        actualLevel
    )
    updateSkillsLevels[indexClicked] = getMaxLevel(
        filteredLevels.length,
        upgradeLevel
    )
}

const UpdateSkillPoints = (
    updatePoints,
    skillsLevels,
    indexClicked,
    maxSkillPoints,
    charLevel,
    skillInfo
) => {
    const updateSkillsLevels = [...skillsLevels]
    const actualLevel = skillsLevels[indexClicked]
    const maxLevel = skillInfo.levelsInfo.length

    if (updatePoints === 0) {
        updateSkillsLevels[indexClicked] = getMinimumLevel(indexClicked)
    } else if (updatePoints > 1) {
        updagradeMax(
            skillInfo,
            charLevel,
            maxSkillPoints,
            updatePoints,
            updateSkillsLevels,
            actualLevel,
            indexClicked
        )
    } else if (
        ableToUpdate(
            actualLevel,
            updatePoints,
            maxLevel,
            skillInfo,
            charLevel,
            maxSkillPoints
        )
    ) {
        const updateSkillPoints =
            actualLevel + updatePoints === 0 && indexClicked === 0
                ? 1
                : actualLevel + updatePoints

        updateSkillsLevels[indexClicked] = updateSkillPoints
    }
    return updateSkillsLevels
}

export default UpdateSkillPoints
